import axiosInstance from '../../config/axiosConfig';
import { urlUnidades } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todas las unidades
export async function getUnidades() {
  try {
    const response = await axiosInstance.get(urlUnidades);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching unidades:', error);
    throw error;
  }
}

export async function getUnidadesPorEmpresa(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlUnidades}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching unidades by company:', error);
    throw error;
  }
}

export async function getUnidadId(id) {
  try {
    const response = await axiosInstance.get(`${urlUnidades}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching unidad with id ${id}:`, error);
    throw error;
  }
}

export async function getUnidadPorActivo(act_codigo) {
  const response = await axiosInstance.get(`${urlUnidades}/por-activo/${act_codigo}`);
  return extractDataObject(response);
}

export async function createUnidades(formulario) {
  try {
    const response = await axiosInstance.post(urlUnidades, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating unidad:', error);
    throw error;
  }
}

export async function updateUnidades(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlUnidades}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating unidad ${id}:`, error);
    throw error;
  }
}

export async function deleteUnidades(id) {
  try {
    const response = await axiosInstance.delete(`${urlUnidades}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting unidad ${id}:`, error);
    throw error;
  }
}

export async function habilitarUnidad(id) {
  try {
    const response = await axiosInstance.put(`${urlUnidades}/${id}/habilitar`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error habilitando unidad ${id}:`, error);
    throw error;
  }
}

export async function deshabilitarUnidad(id) {
  try {
    const response = await axiosInstance.put(`${urlUnidades}/${id}/deshabilitar`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deshabilitando unidad ${id}:`, error);
    throw error;
  }
}